import { render, staticRenderFns } from "./BlockType107.vue?vue&type=template&id=124e37ba&scoped=true"
import script from "./BlockType107.vue?vue&type=script&lang=ts"
export * from "./BlockType107.vue?vue&type=script&lang=ts"
import style0 from "./BlockType107.vue?vue&type=style&index=0&id=124e37ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e37ba",
  null
  
)

export default component.exports